import { observer } from "mobx-react";
import CreateRmaFuqStore from "../stores/create-rma-fuq-store";
import { IOption } from "../../../components/inputs/select-dropdown-grouped/select-dropdown-grouped";
import useTranslation from "../../../translation/hooks/translation-hook";
import SelectDropdownMulti from "../../../components/inputs/select-dropdown-multi/select-dropdown-multi";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";

interface multipleChoiceFuqQuestionProps {
    question: CreateRmaFuqStore;
    required?: boolean;
}

const MultipleChoiceCRmaFuqAnswer: React.FC<multipleChoiceFuqQuestionProps> = observer(({question, required = false}) => {

    const { getTranslation } = useTranslation();
    const { getTranslation: _getDashboardTranslation } = useDashboardTranslation();
    const pageScope = "dashboard-create-rma";

    const dropDownOptions: IOption[] = question.answers.map((answer) => { 
        return {
            label: getTranslation(answer.displayName),
            value: answer.id!
        };
    });

    const onSelectedAnswer = (answerIds: number[]) => {
        const selectedAnswers = question.answers.filter(answer => answerIds.includes(answer.id!));
        /** should never happen */
        if (!selectedAnswers) {
            console.log("no answers were found");
            return;
        }
        question.resetAllAnswersSelections();
        selectedAnswers.map(answer => question.setSelectedAnswer(answer, getTranslation));
    } 

    const getSelectedOptions = ():IOption[] => {
        const selectedAnswers = question.answers.filter(answer => answer.isSelected);
        return dropDownOptions.filter(option => selectedAnswers.find(answer => answer.id === option.value));
    }

    return(
        <SelectDropdownMulti 
            options={dropDownOptions}
            value={getSelectedOptions()}
            onChange={(v) => onSelectedAnswer(v.map(val=>val.value) as number[])}
            required={required}
            isSearchable={false}
            placeholder={_getDashboardTranslation('SELECT_ONE_OR_MORE_PLACEHOLDER', pageScope)}
            target={null}
        />  
    );


});
export default MultipleChoiceCRmaFuqAnswer;